import { RootState } from 'app/store';

export const webPushSubscriptionSelector = ({ webPush }: RootState) => webPush.subscription;

export const notificationWebPushDialogSelector = ({ webPush }: RootState) => webPush.dialog;
